import {Country, countryNames} from '../country';
import {Dropdown} from './dropdown';

const COUNTRY_OPTIONS_FR: Dropdown<Country>[] = Object.entries(countryNames).map(([key, value]) => {
  return {
    name: value.fr,
    value: key as Country,
  };
});

const COUNTRY_OPTIONS_EN: Dropdown<Country>[] = Object.entries(countryNames).map(([key, value]) => {
  return {
    name: value.en,
    value: key as Country,
  };
});

export const COUNTRY_OPTIONS = {
  en: COUNTRY_OPTIONS_EN,
  fr: COUNTRY_OPTIONS_FR,
};
